import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/**
 * 静态路由
 */
const routes = [

  {
    path: '/',
    name: 'SMS_466765012',
    component: () => import('@/views/SMS_466765012.vue'),
  },
  {
    path: '/SMScode',
    name: 'SMScode',
    component: () => import('@/views/SMS_475780409.vue'),
  },
  {
    path: '/agree',
    name: 'agree',
    component: () => import('@/views/agreement.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
